"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearStor = exports.checkLogin = exports.getLogin = exports.getCurrentState = exports.setCurrentState = exports.setLogin = void 0;
function setLogin(name, surname) {
    localStorage.setItem('name', name);
    localStorage.setItem('surname', surname);
}
exports.setLogin = setLogin;
function setCurrentState(level, round) {
    localStorage.setItem('current-level', level);
    localStorage.setItem('current-round', `${round}`);
}
exports.setCurrentState = setCurrentState;
function getCurrentState() {
    const level = localStorage.getItem('current-level');
    const round = localStorage.getItem('current-round');
    return { level, round };
}
exports.getCurrentState = getCurrentState;
function getLogin() {
    const name = localStorage.getItem('name');
    const surname = localStorage.getItem('surname');
    return { name, surname };
}
exports.getLogin = getLogin;
function checkLogin() {
    return localStorage.name && localStorage.surname;
}
exports.checkLogin = checkLogin;
function clearStor() {
    localStorage.clear();
}
exports.clearStor = clearStor;
